<template>
  <div>
    <Head :title="form.name" />
    <h1 class="mb-8 text-3xl font-bold">
      <Link class="text-indigo-400 hover:text-indigo-600" href="/components">Komponenty</Link>
      <span class="text-indigo-400 font-medium">/</span>
      {{ form.name }}
    </h1>
    <trashed-message v-if="component.deleted_at" class="mb-6" @restore="restore"> Tato komponenta je smazána. </trashed-message>
    <div class="max-w-3xl bg-white rounded-md shadow overflow-hidden">
      <form @submit.prevent="update">
        <div class="flex flex-wrap -mb-8 -mr-6 p-8">
          <text-input v-model="form.name" :error="form.errors.name" class="pb-8 pr-6 w-full" label="Název" />
          <text-input v-model="form.warranty" :error="form.errors.warranty" class="pb-8 pr-6 w-full lg:w-1/2" label="Záruka" />
          <text-input v-model="form.price" :error="form.errors.price" type="number" step="any" class="pb-8 pr-6 w-full lg:w-1/2" label="Cena" />
          <SelectInput v-model="form.type" :error="form.errors.type" class="pb-8 pr-6 w-full" label="Vyberte typ komponenty">
            <option v-for="(componentType, index) in componentTypes" :key="index" :value="index">{{ componentType }}</option>
          </SelectInput>
          <SelectInput v-model="form.group" :error="form.errors.group" class="pb-8 pr-6 w-full" label="Vyberte skupinu komponenty">
            <option v-for="(componentGroup, index) in componentGroups" :key="index" :value="index">{{ componentGroup }}</option>
          </SelectInput>
          <text-input v-model="form.power_cap" :error="form.errors.power_cap" type="number" step="any" class="pb-8 pr-6 w-full lg:w-1/2" label="Výkon nebo kapacita (kWp / kWh / kW)" />
          <text-area-input v-model="form.description" :error="form.errors.description" class="pb-8 pr-6 w-full" label="Popis" />
          <!-- <file-input v-if="form.type === 'panel'" v-model="form.offer" :error="form.errors.offer" class="pb-8 pr-6 w-full lg:w-1/2" type="file" accept="application/pdf" label="PDF nabídka dle panelu" /> -->
          <!-- <a v-if="component.offer" class="flex items-center text-indigo-400 hover:text-indigo-600 font-bold rounded-full" :href="component.offer" target="_blank">Aktuální PDF</a> -->
        </div>

        <div v-if="form.type === 'panel' || form.type === 'inverter' || form.type === 'battery' || form.type === 'wallbox'" class="flex flex-wrap -mr-6 mb-8 p-8 bg-orange-50 border-t border-orange-100">
          <div class="w-full text-lg font-bold">Data pro nabídku (listy před nabídkou)</div>
          <text-input v-model="form.offer_name" :error="form.errors.offer_name" maxlength="30" class="mt-6 pb-8 pr-6 w-full" label="Krátký název (max. 30 znaků)" />
          <text-area-input v-model="form.offer_description" :error="form.errors.offer_description" maxlength="500" class="pb-8 pr-6 w-full" label="Popis (max. 500 znaků)" />
          <file-input v-model="form.offer_photo" :error="form.errors.offer_photo" class="pb-8 pr-6 w-full" type="file" accept="image/*" label="Obrázek (max. 100 kB)" />
          <img v-if="component.offer_photo_path" class="max-w-[100px] block mt-4" :src="component.offer_photo_path" />
        </div>

        <div class="flex items-center px-8 py-4 bg-gray-50 border-t border-gray-100">
          <button v-if="!component.deleted_at" class="text-red-600 hover:underline" tabindex="-1" type="button" @click="destroy">Smazat komponentu</button>
          <loading-button :loading="form.processing" class="btn-indigo ml-auto" type="submit">Upravit komponentu</loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import TextAreaInput from '@/Shared/TextAreaInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'
import TrashedMessage from '@/Shared/TrashedMessage'
import FileInput from '@/Shared/FileInput'

export default {
  components: {
    Head,
    Link,
    LoadingButton,
    SelectInput,
    TextInput,
    TextAreaInput,
    TrashedMessage,
    FileInput,
  },
  layout: Layout,
  props: {
    component: Object,
    componentTypes: Object,
    componentGroups: Object,
  },
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
        _method: 'put',
        name: this.component.name,
        price: this.component.price,
        warranty: this.component.warranty,
        type: this.component.type,
        group: this.component.group,
        power_cap: this.component.power_cap,
        description: this.component.description,
        offer_name: this.component.offer_name,
        offer_description: this.component.offer_description,
        offer_photo: this.component.offer_photo,
      }),
    }
  },
  methods: {
    update() {
      this.form.post(`/components/${this.component.id}`)
    },
    destroy() {
      if (confirm('Opravdu chcete smazat tuto komponentu?')) {
        this.$inertia.delete(`/components/${this.component.id}`)
      }
    },
    restore() {
      if (confirm('Opravdu chcete obnovit tuto komponentu?')) {
        this.$inertia.put(`/components/${this.component.id}/restore`)
      }
    },
  },
}
</script>
